module.exports = __webpack_public_path__ + "img/slide_billma.5e16f1ea.svg";